
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'

class ProcessingAgencyOrganizedUnitConfigMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.processingAgencyOrganizedUnitConfig)
    }
  }

  submitProcessingAgencyOrganizedUnitConfig (values) {
    const processingAgencyOrganizedUnitConfig = {
      ProcessingAgencyOrganizedUnitConfigId: this.props.processingAgencyOrganizedUnitConfig?.processingAgencyOrganizedUnitConfigId,
      OrganizedUnitId: values.organizedUnitId,
      User: values.user,
      Password: values.password,
      ProcessingAgencyCommunicationServiceId: this.props.processAgencyCommunicationServiceId
    }

    this.props.actions.submitProcessingAgencyOrganizedUnitConfig(processingAgencyOrganizedUnitConfig, this.props.processAgencyCommunicationServiceId)
  }

  render () {
    const {
      t, handleSubmit,
      showModal,
      combos: { organizedUnitsAllCombo }
    } = this.props
    const tKey = 'MASTERS.PROCESSING_AGENCY_ORGANIZED_UNIT_CONFIG.MODAL.'
    return (
      <Modal id="processingAgencyOrganizedUnitConfigMasterModal" className="_nf" show={showModal} onHide={() => this.props.actions.showProcessingAgencyOrganizedUnitConfigModal(false)} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitProcessingAgencyOrganizedUnitConfig.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={() => this.props.actions.showProcessingAgencyOrganizedUnitConfigModal(false)}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="user"
                controlLabel={t(`${tKey}USER`)}
                placeholder={t(`${tKey}USER`)}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="password"
                controlLabel={t(`${tKey}PASSWORD`)}
                placeholder={t(`${tKey}PASSWORD`)}
                required={[true]}
                maxLength={50}
              />
              <Field
                component={InputSelect}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitId"
                controlLabel={t(`${tKey}ORGANIZED_UNIT`)}
                placeholder={t(`${tKey}ORGANIZED_UNIT`)}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editProcessingAgencyOrganizedUnitConfig',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.PROCESSING_AGENCY_ORGANIZED_UNIT_CONFIG.VALIDATION.'
    if (!props.processingAgencyOrganizedUnitConfig?.processingAgencyOrganizedUnitConfigId && props.OUsAssigned.find(x => x === values.organizedUnitId)) {
      error.organizedUnitId = props.t(`${tKey}OU`)
    }
    if (!values.user) {
      error.user = props.t(`${tKey}USER`)
    }
    if (!values.password) {
      error.password = props.t(`${tKey}PASSWORD`)
    }
    return Object.keys(error).length > 0 ? error : {}
  }
})(ProcessingAgencyOrganizedUnitConfigMasterModal)
